import './Report20XX.css';

const report2024 = () => {
  return (
    <div className='Report20XX_wrapper'>
      {/* THE CHAMP */}
      <div className='Report20XX_header'>The Year I Got Mine</div>
      <div className='Report20XX_champPlaque'>
        <img
          className='Report20XX_champPlaquePic'
          src='/images/2024/2024Plaque.JPG'
          alt='2024 Plaque'
        />
      </div>
      <div className='Report20XX_champTextShrink'>
        <p>
          &nbsp;&nbsp;&nbsp;&nbsp;We had another great year of "Firsts" in 2024.
          Our First-Place player this year--Antony Saccenti--made his fourth
          Final, but his very first Championship. Our streak reached (all) eight
          years for the tournament yielding up a first-time Finalist: indeed,
          both Preston and (long-suffering) Scott got their first Shirts this
          time 'round.
        </p>
        <br />
        <p>
          Christy Applegate joined us as a new permanent member to the group,
          our first such since Aaron, Chad & Joe joined way back in '20. Henry
          Dove attended his first Top Toad as well, taking over the emergency
          pinch-hitter role from Chris Yaure.
        </p>
        <br />
        <p>
          We welcomed back some absent Toads in '24, with Andy making his first
          return to the 'Pole since 2019, plus we got Rodney back after just one
          year away.
        </p>
        <br />
        <p>
          And we started a new tradition. Once again, the best ideas aren't
          mine. Since 2018, the last-place finisher has gotten a coffee mug to
          commemorate their disastrous bad time. This year, rather than give out
          a second mug, someone suggested that No One Shall Receive Two Mugs.
          Thus, the Mug will now forever go to whoever did the worst AND ALSO
          has never been "Mugged." Awesome. This means even Andrew is getting
          Mugged someday! Who can be the last to avoid it??...
        </p>
      </div>
      <div className='Report20XX_champPic'>
        <img
          className='Report20XX_champPlayerPic'
          src='/images/2024/2024Champ.JPG'
          alt='Antony Saccenti displays plaque'
        />
      </div>
      <div className='Report20XX_padding' />
      {/* THE TOADS */}
      <div className='Report20XX_header'>The Toads of 2024</div>
      <div className='Report20XX_toads'>
        <img
          className='Report20XX_toadsPic'
          src='/images/2024/2024Group.JPG'
          alt='The 2024 Top Toads Group'
        />
      </div>
      <ul className='Report20XX_toadsText'>
        <li>Christy Applegate (MD)</li>
        <li>Rodney Bacigalupo (AR)</li>
        <li>Aaron Blair (MD)</li>
        <li>Randy Buehler (WA)</li>
        <li>Henry Dove (MD)</li>
        <li>Andrew Emerick (CT)</li>
        <li>Andy Latto (MA)</li>
        <li>Marcy Morelli (PA)</li>
        <li>Rob Murray (NJ)</li>
        <li>Antony Saccenti (MD)</li>
        <li>Donte Saccenti (MD)</li>
        <li>Preston Saccenti (MD)</li>
        <li>Scott Saccenti (MD)</li>
        <li>Hilary Smith (PA)</li>
        <li>Kyle Smith (PA)</li>
        <li>Dalton Versak (PA)</li>
        <li>Chad Weaver (PA)</li>
        <li>Chris Wildes (DC)</li>
        <li>Joe Yaure (RI)</li>
        <li>Eugene Yee (MD)</li>
      </ul>
      <div className='Report20XX_padding' />
      {/* THE GAMES */}
      <div className='Report20XX_header'>The Games of 2024</div>
      <ul className='Report20XX_gamesText'>
        <li>7 Wonders</li>
        <li>Alhambra</li>
        <li>Carcassonne</li>
        <li>Castles of Mad King Ludwig</li>
        <li>Coloretto</li>
        <li>Egizia</li>
        <li>For Sale</li>
        <li>Incan Gold</li>
        <li>Ingenious</li>
        <li>Istanbul</li>
        <li>Las Vegas</li>
        <li>Luxor</li>
        <li>Medici</li>
        <li>Puerto Rico</li>
        <li>Ra</li>
        <li>Saint Petersburg</li>
        <li>Splendor</li>
        <li>Stone Age</li>
        <li>Thurn & Taxis</li>
        <li>Ticket to Ride</li>
        <li>Ticket to Ride: World Maps</li>
        <li>Vegas Showdown</li>
      </ul>
      <div className='Report20XX_games'>
        <img
          className='Report20XX_gamesPic'
          src='/images/2024/2024Overhead.JPG'
          alt='Wide shot of several games being played at Top Toad'
        />
      </div>
      <div className='Report20XX_extraPics'>
        <img
          className='Report20XX_extraPic1'
          src='/images/2024/2024SaintPetePlus.JPG'
          alt='The group mid-game'
        />
        <img
          className='Report20XX_extraPic2'
          src='/images/2024/2024AntonyMarcyThurn.JPG'
          alt='Marcy Morelli and Antony Saccenti play Thurn and Taxis'
        />
        <img
          className='Report20XX_extraPic3'
          src='/images/2024/2024DonteSmiles.JPG'
          alt='Donte Saccenti looks to camera alongside Joe Yaure, Chris Wildes and Dalton Versak'
        />
        <img
          className='Report20XX_extraPic4'
          src='/images/2024/2024ChristyRobChadEgizia.JPG'
          alt='Hilary Smith, Chad Weaver, Christy Applegate and Rob Murray play Egizia'
        />
        <img
          className='Report20XX_extraPic5'
          src='/images/2024/2024AntonyAndrew.JPG'
          alt='Antony Saccenti watches Andrew Emerick gesture to the heavens'
        />
        <img
          className='Report20XX_extraPic6'
          src='/images/2024/2024ChrisAndy.JPG'
          alt='Andy Latto mugs for the camera while Chris Wildes observes'
        />
        <img
          className='Report20XX_extraPic7'
          src='/images/2024/2024AlhambraAndMore.JPG'
          alt='The group mid-game'
        />
        <img
          className='Report20XX_extraPic8'
          src='/images/2024/2024PrestonStare.jpg'
          alt='Preston Saccenti points to the board'
        />
        <img
          className='Report20XX_extraPic9'
          src='/images/2024/2024RobAndyJoe.JPG'
          alt='Joe Yaure, Rob Murray and Andy Latto play Terraforming Mars'
        />
        <img
          className='Report20XX_extraPic10'
          src='/images/2024/2024MarcyPrestonRodneyKyle.JPG'
          alt='Rodney Bacigalupo, Preston Saccenti, Kyle Smith and Marcy Morelli play Castles of Mad King Ludwig'
        />
        <img
          className='Report20XX_extraPic11'
          src='/images/2024/2024RobHilary.JPG'
          alt='Rob Murray, Christy Applegate and Hilary Smith play Egizia'
        />
        <img
          className='Report20XX_extraPic12'
          src='/images/2024/2024EugeneAaron.JPG'
          alt='Eugene Yee and Aaron Blair play Egizia'
        />
        <img
          className='Report20XX_extraPic13'
          src='/images/2024/2024LunchBreak.JPG'
          alt='Group Breaks for Lunch'
        />
        <img
          className='Report20XX_extraPic14'
          src='/images/2024/2024DinnerBreak.JPG'
          alt='Group Breaks for Dinner'
        />
        <img
          className='Report20XX_extraPic15'
          src='/images/2024/2024GroupGag.JPG'
          alt='2024 Top Toad Group Gag Shot'
        />
        <img
          className='Report20XX_extraPic16'
          src='/images/2024/2024FinalFour.JPG'
          alt='The 2024 Top Toad Finalists, Preston Saccenti, Scott Saccenti, Antony Saccenti and Andrew Emerick'
        />
      </div>
    </div>
  );
};

export default report2024;
